module.exports = require('./dist/es5/HTMLParser.js').default
